/**
 * Zimply Natural — Partner-/Affiliate-Tracking (Last-touch)
 * --------------------------------------------------------------------------
 * Liest die Partner-Parameter aus Partnerlinks und gibt sie an die Bestellung
 * weiter, damit Ninox die Partnerzuordnung vornehmen kann.
 *
 *   Partnerlink-Beispiel:  ?m=Individual-04103&n=&zp=Yscm1RLkya
 *     zp = Partner-ID
 *     m  = Mischung (Produkt-Code)
 *     n  = Vorname fürs Fläschchenetikett (darf leer sein → bleibt leer)
 *
 * Modell: LAST-TOUCH. Ein neuer Partnerlink überschreibt die gespeicherte
 * Zuordnung. Pro Bestellung wird genau EIN Partner übergeben.
 *
 * Übergabe an die Bestellung — bewusst doppelt, damit kein Weg verloren geht:
 *   1) Cart-Attribut  (order-level)  → der reguläre Warenkorb-Weg.
 *   2) Line-Item-Property (versteckt) → Fallback für den DYNAMISCHEN CHECKOUT
 *      ("Jetzt kaufen" / Shop Pay / PayPal Express) auf der PDP, der den
 *      Warenkorb — und damit Cart-Attribute — komplett überspringt.
 *
 * Ninox liest den Partner an der Bestellung in dieser Reihenfolge:
 *   a) Order-Attribut  attributes['partner_id']
 *   b) falls leer → Line-Item-Property  '_zp'  (Direkt-Checkout-Bestellungen)
 *
 * Persistente Kunde→Partner-Bindung, generische Folgebestellungen und der
 * NEM-Ausschluss passieren NICHT hier, sondern in Ninox/n8n.
 */
(function () {
  'use strict';

  var COOKIE_NAME = 'zimply_partner';
  var COOKIE_DAYS = 90; // Attributionsfenster bis zur Bestellung (Default — mit Thomas abstimmbar)

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function getQueryParam(name) {
    try {
      return new URLSearchParams(window.location.search).get(name);
    } catch (e) {
      return null;
    }
  }

  function setCookie(name, value, days) {
    var maxAge = days * 24 * 60 * 60;
    var secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie =
      name + '=' + encodeURIComponent(value) +
      '; path=/; max-age=' + maxAge + '; SameSite=Lax' + secure;
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function readPartner() {
    var raw = getCookie(COOKIE_NAME);
    if (!raw) return null;
    try {
      var data = JSON.parse(raw);
      return data && data.zp ? data : null;
    } catch (e) {
      return null;
    }
  }

  /* 1) Aus der URL erfassen — Last-touch: neuer zp überschreibt den alten. */
  function capture() {
    var zp = getQueryParam('zp');
    if (!zp) return readPartner(); // kein neuer Partnerlink → bestehende Zuordnung behalten
    var data = {
      zp: zp,
      m: getQueryParam('m') || '',
      n: getQueryParam('n') || ''
    };
    setCookie(COOKIE_NAME, JSON.stringify(data), COOKIE_DAYS);
    try { sessionStorage.removeItem('zimply_partner_synced'); } catch (e) {} // erzwingt Re-Sync
    return data;
  }

  /* 2) Ein Partner pro Bestellung → als Cart-Attribut auf den Warenkorb. */
  function syncCartAttributes(data) {
    if (window.Shopify && Shopify.designMode) return; // im Theme-Editor keine Cart-Mutationen

    var marker = null;
    try { marker = sessionStorage.getItem('zimply_partner_synced'); } catch (e) {}
    if (marker === data.zp) return; // in dieser Session bereits synchronisiert

    fetch(root() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        attributes: {
          partner_id: data.zp,
          partner_mischung: data.m || '',
          partner_name: data.n || ''
        }
      })
    })
      .then(function () {
        try { sessionStorage.setItem('zimply_partner_synced', data.zp); } catch (e) {}
      })
      .catch(function () {});
  }

  /* 3) Fallback für dynamischen Checkout → versteckte Line-Item-Properties. */
  function injectLineItemProps(data) {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      addProp(forms[i], '_zp', data.zp);
      if (data.m) addProp(forms[i], '_m', data.m);
      if (data.n) addProp(forms[i], '_n', data.n);
    }
  }

  function addProp(form, key, value) {
    var existing = form.querySelector('input[data-zimply-partner="' + key + '"]');
    if (existing) {
      existing.value = value;
      return;
    }
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[' + key + ']';
    input.value = value;
    input.setAttribute('data-zimply-partner', key);
    form.appendChild(input);
  }

  function init() {
    var data = capture();
    if (!data || !data.zp) return;

    syncCartAttributes(data);
    injectLineItemProps(data);

    // Produktformulare werden bei Variantenwechsel ggf. neu gerendert → erneut injizieren (debounced).
    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        injectLineItemProps(data);
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
